import React from "react";
import { Box, Flex, Stack, Text } from "@chakra-ui/react";
import { OpportunityDocumentsProps } from "./OpportunityDocuments.types";
import { SectionContainer } from "../../SectionContainer";
import { VeriHeading } from "@verivest/shared-components";
import { DocumentBox } from "./OpportunityDocumentBox";

export const OpportunityDocuments: React.FC<OpportunityDocumentsProps> = ({
  manager,
  opportunity,
  ...rest
}) => {
  if (!manager) {
    return <></>;
  }

  return (
    <SectionContainer noPadding bg="background" mt="48px" {...rest}>
      <Box>
        <VeriHeading textStyle="h4" mb="24px">
          Documents
        </VeriHeading>
        <Text mb="24px" textStyle="bodyRegular">
          The documents below have been provided by {manager.name} for{" "}
          {opportunity.name}. To view or download a document, you must affirm
          the Verivest non-disclosure agreement. Click on any document name to
          view the agreement.
        </Text>

        {!opportunity.documents?.length && (
          <Flex
            borderRadius={4}
            bg="bg.lighter"
            justifyContent="center"
            px="12px"
            py="16px"
          >
            <Text
              color="text.grey"
              fontStyle="italic"
              textAlign="center"
              width="100%"
            >
              No documents found for this opportunity.
            </Text>
          </Flex>
        )}

        <Stack spacing={4}>
          {opportunity.documents?.map((d) => (
            <DocumentBox
              key={d.id}
              id={String(d.id) || ""}
              title={d.filename || ""}
              date={Number(d.contentDate) || 0}
              filename={d.filename || ""}
            />
          ))}
        </Stack>
      </Box>
    </SectionContainer>
  );
};
